//////LIBRARY//////
import { cloneDeep, filter, find, includes, isEmpty, isNull, isUndefined, map } from 'lodash'
import React, { Fragment, useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
//////COMPONENTS//////
import ToggleFilters from '../../components/Ui/ToggleFilters'
import ToggleInput from '../../components/Ui/ToggleInput'
import { shortcutPicsConfig } from '../../constants/AssetsPicturesConfigList'
import { userPreferencesActionCreators } from '../../store/actions'
import { LabelText } from '../../theme/GlobalCss'
import Theme from '../../theme/theme'

//////STYLED//////
const UserPreferencesWrapper = styled.div`
	position: relative;
	font-size: ${(props) => props.theme.font.fs};
`
const PreferencesTitle = styled(LabelText)`
	font-size: ${(props) => props.theme.font.fm};
	margin-bottom: 30px;
	color: ${(props) => props.theme.colors.primary};
`
const PreferencesPartTitle = styled(LabelText)`
	font-size: ${(props) => props.theme.font.fm};
	margin-bottom: 15px;
`
const PreferencesShortcutsWrapper = styled.div`
	display: grid;
	grid-row-gap: 30px;
	& > :first-child {
		margin-bottom: 0px;
	}
`
const PreferencesShortcutsCategoryWrapper = styled.div`
	display: grid;
	grid-template-columns: 50px min-content;
	grid-column-gap: 20px;
	align-items: center;
`
const PreferencesShortcuts = styled.div`
	display: grid;
	grid-column-gap: 20px;
	grid-template-columns: auto auto auto auto auto auto auto auto;
`
const PreferencesShortcutItem = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
`
const PreferencesShortcutIcon = styled.div`
	width: 50px;
	height: 50px;
	border-radius: 3px;
	margin: 10px 0px;
	background-color: ${(props) => (props.selected ? props.theme.colors.primary : props.theme.colors.eraser)};
	background-image: ${(props) => `url(${props.iconSrc})`};
	background-position: center;
	background-repeat: no-repeat;
	background-size: auto 20px;
`
const PreferencesShortcutLabel = styled.span`
	width: 80px;
`
const PreferencesDisplayWrapper = styled.div`
	margin-top: 50px;
`
const PreferencesDisplayCategoryWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	& > * {
		margin: 0px 10px;
	}
	& > :first-child {
		margin-left: 0px;
	}
	& > :last-child {
		margin-right: 0px;
	}
`
const PreferencesDisplayItem = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	& > :first-child {
		margin-right: 10px;
	}
	display: grid;
	grid-template-columns: 150px min-content;
	grid-column-gap: 20px;
`
const PreferencesNotificationWrapper = styled.div`
	display: grid;
	margin-top: 50px;
	grid-row-gap: 40px;
	& > :first-child {
		margin-bottom: -25px;
	}
`
const PreferencesNotificationCategoryWrapper = styled.div`
	display: grid;
	grid-column-gap: 20px;
	grid-template-columns: 150px max-content;
	& > span {
		font-size: ${(props) => props.theme.font.fm};
	}
`
const PreferencesNotificationSubCategoryWrapper = styled.div`
	display: grid;
	grid-row-gap: 25px;
`
const PreferencesNotificationSubCategory = styled.div`
	display: grid;
	grid-row-gap: 10px;
	grid-template-columns: 1fr;
	& > span {
		font-size: ${(props) => props.theme.font.fm};
		font-style: italic;
	}
	& > div {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-column-gap: 50px;
	}
`
const PreferencesNotificationItem = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	& > :first-child {
		margin-right: 10px;
	}
`
//////STYLED//////

const UserPreferences = (props) => {
	let history = useHistory()

	const [showModal, setShowModal] = useState(false)
	const [row, setRow] = useState({})

	// Shortcuts
	const [numberShortcuts, setNumberShortcuts] = useState(0)
	const [shortcuts, setShortcuts] = useState([])

	/* Displays => We might handle several ones in future ? */
	// Prices
	const [isPricesTTC, setIsPricesTTC] = useState(true)

	// Notifications
	const [notifications, setNotifications] = useState([])

	const { user, translations, userPreferences } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			userPreferences: state.userPreferences,
		}),
		shallowEqual
	)

	const actionsUserPreferences = bindActionCreators(userPreferencesActionCreators, useDispatch())

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handleModal = (dataRow) => {
		setRow({ ...dataRow })
		setShowModal((prevState) => !prevState)
	}

	const handlePreferenceChange = (idPreference, typeURL, category, prevValue, newValue) => {
		if (newValue !== prevValue) {
			// Keep the limitation of shortcuts selected
			switch (typeURL) {
				case 'shortcut':
					let nbShortcutsSelected = cloneDeep(numberShortcuts)

					// Prevent any action if shortcuts number is above limitation
					if (nbShortcutsSelected <= 8) {
						if (newValue && !prevValue) {
							nbShortcutsSelected++
							actionsUserPreferences.setIsActivedPreference(true)
						} else {
							nbShortcutsSelected--
							nbShortcutsSelected === 0 && actionsUserPreferences.setIsActivedPreference(false)
						}
						/* 	(newValue && !prevValue) ? 
							nbShortcutsSelected++
							
							:
							nbShortcutsSelected-- */

						// We recheck again
						if (nbShortcutsSelected <= 8) {
							let sCuts = cloneDeep(shortcuts)
							sCuts = map(sCuts, (cat) => {
								if (cat.translationKey === category) {
									map(cat.userShorcuts, (elem) => {
										if (elem.id === idPreference) elem.isSelected = newValue
										return elem
									})
								}
								return cat
							})
							setShortcuts(sCuts)
							setNumberShortcuts(nbShortcutsSelected)

							actionsUserPreferences.setUserPreference(idPreference, typeURL, newValue)
						}
					}
					break
				case 'notification':
					actionsUserPreferences.setUserPreference(idPreference, typeURL, newValue)
					break
				default:
					break
			}
		}
	}

	const handleDisplayChange = (type, prevValue, newValue) => {
		if (newValue !== prevValue) {
			switch (type) {
				case 'isPricesTTC':
					setIsPricesTTC(newValue)
					actionsUserPreferences.setUserPreference('', 'price-ttc', newValue)
					break
				default:
					break
			}
		}
	}

	/////////////////////////////// CONFIG //////////////////////////////////////

	const notificationsConfig = [
		{
			translationKey: 'page__preference__notifications__followed_deliveryman',
			notifications: [
				{
					translationKey: 'page__preference__notifications__followed_deliveryman_arrival',
					fields: [
						{ id: 1, translationKey: 'common__text__notifMail' },
						{ id: 2, translationKey: 'common__text__notifApplication' },
						{ id: 3, translationKey: 'common__text__notifSMS' },
					],
				},
				{
					translationKey: 'page__preference__notifications__followed_deliveryman_departure',
					fields: [
						{ id: 4, translationKey: 'common__text__notifMail' },
						{ id: 5, translationKey: 'common__text__notifApplication' },
						{ id: 6, translationKey: 'common__text__notifSMS' },
					],
				},
				{
					translationKey: 'page__preference__notifications__followed_deliveryman_recap_delivery',
					fields: [{ id: 7, translationKey: 'common__text__notifMail' }],
				},
			],
		},
		{
			translationKey: 'page__preference__notifications__followed_maintainer',
			notifications: [
				{
					translationKey: 'page__preference__notifications__followed_arrival',
					fields: [
						{ id: 8, translationKey: 'common__text__notifMail' },
						{ id: 9, translationKey: 'common__text__notifApplication' },
						{ id: 10, translationKey: 'common__text__notifSMS' },
					],
				},
				/*{
					"translationKey":'page__preference__notifications__followed_departure',
					"fields":[
						{"id":11,"translationKey":"common__text__notifMail"},
						{"id":12,"translationKey":"common__text__notifApplication"},
						{"id":13,"translationKey":"common__text__notifSMS"},
					]
				},*/
			],
		},
		{
			translationKey: 'page__preference__notifications__stock_status',
			notifications: [
				{
					translationKey: 'page__preference__notifications__stock_status_recap_email',
					fields: [
						{ id: 14, translationKey: 'common__text__daily' },
						{ id: 15, translationKey: 'common__text__weekly' },
						{ id: 16, translationKey: 'common__text__monthly' },
					],
				},
			],
		},
		{
			translationKey: 'page__preference__notifications__salesOrder_status',
			notifications: [
				{
					translationKey: 'page__preference__notifications__salesOrder_status',
					fields: [
						{ id: 17, translationKey: 'common__text__daily' },
						{ id: 18, translationKey: 'common__text__weekly' },
						{ id: 19, translationKey: 'common__text__monthly' },
					],
				},
			],
		},
		/*{
			translationKey: 'Evenement utilisateur',
			notifications: [
				{
					"translationKey":'Connexion',
					"fields":[
						{"id":20,"translationKey":"common__text__notifMail"},
					]
				},
			]
		},*/
		{
			translationKey: 'page__preference__notifications__incident',
			notifications: [
				{
					translationKey: 'page__preference__notifications__incident_material',
					fields: [
						{ id: 21, translationKey: 'common__text__notifMail' },
						{ id: 23, translationKey: 'common__text__notifSMS' },
					],
				},
				{
					translationKey: 'page__preference__notifications__kiosk_state',
					fields: [
						{ id: 22, translationKey: 'common__text__notifMail' },
						{ id: 24, translationKey: 'common__text__notifSMS' },
					],
				},
			],
		},
	]

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		if (isEmpty(translations)) return
		actionsUserPreferences.getUserPreferences()
	}, [translations])

	useEffect(() => {
		// Setting shortcuts in hook
		if (!isEmpty(userPreferences.items.userShorcutsCategories)) {
			setShortcuts(userPreferences.items.userShorcutsCategories)

			let nbScuts = 0
			// Get how many shortcuts we already have
			map(userPreferences.items.userShorcutsCategories, (cat) => {
				map(cat.userShorcuts, (elem) => {
					if (elem.isSelected) nbScuts++
				})
			})
			setNumberShortcuts(nbScuts)
		}
		// Setting displays
		// Prices
		setIsPricesTTC(userPreferences.items.isPricesTTC)

		// Setting notifications
		setNotifications(userPreferences.items.userNotifications)
	}, [userPreferences.items])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			<UserPreferencesWrapper>
				<PreferencesTitle>{translations['page__preference__title']}</PreferencesTitle>
				{!isEmpty(shortcuts) && translations && (
					<PreferencesShortcutsWrapper>
						<PreferencesPartTitle>{translations['page__preference__shortcuts']} :</PreferencesPartTitle>
						{map(shortcuts, (shortcutCategory) => {
							return (
								<PreferencesShortcutsCategoryWrapper>
									<LabelText>{translations[shortcutCategory.translationKey]}</LabelText>
									<PreferencesShortcuts>
										{map(shortcutCategory.userShorcuts, (elem) => {
											const pic = find(shortcutPicsConfig, { id: elem.id })
											return (
												<PreferencesShortcutItem>
													<ToggleInput
														checked={elem.isSelected}
														onChangeHandler={() =>
															handlePreferenceChange(
																elem.id,
																'shortcut',
																shortcutCategory.translationKey,
																elem.isSelected,
																!elem.isSelected
															)
														}
														name={`preferencesShortcutItem_${elem.id}`}
														prevColor={Theme.colors.eraser}
													/>
													<PreferencesShortcutIcon
														selected={elem.isSelected}
														iconSrc={`${!isUndefined(pic) && pic.picture}`}
													/>
													<PreferencesShortcutLabel>{translations[elem.translationKey]}</PreferencesShortcutLabel>
												</PreferencesShortcutItem>
											)
										})}
									</PreferencesShortcuts>
								</PreferencesShortcutsCategoryWrapper>
							)
						})}
					</PreferencesShortcutsWrapper>
				)}
				{translations && (
					<PreferencesDisplayWrapper>
						<PreferencesPartTitle>{translations['page__preference__prices__display_customization']} :</PreferencesPartTitle>
						<PreferencesDisplayCategoryWrapper>
							{!isNull(isPricesTTC) && (
								<PreferencesDisplayItem>
									<span>{translations['page__preference__prices__display']} :</span>
									<ToggleFilters
										checked={isPricesTTC}
										onChangeHandler={() => handleDisplayChange('isPricesTTC', isPricesTTC, !isPricesTTC)}
										name={`preferencesDisplayItem_isPricesTTC`}
										labelPrev="HT"
										labelNext="TTC"
										size="large"
									/>
								</PreferencesDisplayItem>
							)}
						</PreferencesDisplayCategoryWrapper>
					</PreferencesDisplayWrapper>
				)}
				{!isEmpty(notifications) && translations && (
					<PreferencesNotificationWrapper>
						<PreferencesPartTitle>{translations['page__preference__notifications']} :</PreferencesPartTitle>
						{map(notificationsConfig, (category) => {
							// If nothing is shown in subcategory
							// Hide category
							let showCat = false

							map(category.notifications, (subcat) => {
								// First we get all ids of subcategory
								const ids = map(subcat.fields, 'id')
								const visible_notifications = filter(notifications, { isVisible: true })

								// Then, we check if this id exist in store and if we can show it
								map(visible_notifications, (e) => {
									if (includes(ids, e.id)) {
										showCat = true
									}
								})
							})

							return !showCat ? null : (
								<PreferencesNotificationCategoryWrapper>
									<span>{translations[category.translationKey]} :</span>
									<PreferencesNotificationSubCategoryWrapper>
										{map(category.notifications, (subcat) => {
											// Right here, check if we got at least one element visible
											// Otherwise, we hide the entire subcategory
											let showSubCat = false

											// First we get all ids of subcategory
											const ids = map(subcat.fields, 'id')
											const visible_notifications = filter(notifications, { isVisible: true })

											// Then, we check if this id exist in store and if we can show it
											map(visible_notifications, (e) => {
												if (includes(ids, e.id)) {
													showSubCat = true
												}
											})

											return !showSubCat ? null : (
												<PreferencesNotificationSubCategory>
													<span>{translations[subcat.translationKey]}</span>
													<div>
														{map(subcat.fields, (elem) => {
															const f = find(notifications, (o) => o.id === elem.id)
															return !isUndefined(f) && f.isVisible ? (
																<PreferencesNotificationItem>
																	<span>{translations[elem.translationKey]}</span>
																	<ToggleInput
																		checked={f.isSelected}
																		onChangeHandler={() =>
																			handlePreferenceChange(
																				elem.id,
																				'notification',
																				subcat.translationKey,
																				f.isSelected,
																				!f.isSelected
																			)
																		}
																		name={`preferencesNotificationItem_${elem.id}`}
																	/>
																</PreferencesNotificationItem>
															) : null
														})}
													</div>
												</PreferencesNotificationSubCategory>
											)
										})}
									</PreferencesNotificationSubCategoryWrapper>
								</PreferencesNotificationCategoryWrapper>
							)
						})}
					</PreferencesNotificationWrapper>
				)}
			</UserPreferencesWrapper>
		</Fragment>
	)
}

UserPreferences.propTypes = {}

UserPreferences.defaultPropTypes = {}

export default UserPreferences
